import PropTypes from "prop-types";
import { m } from "framer-motion";
// @mui
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
// hooks
import { useAuthContext } from "src/auth/hooks";
import { useLocales } from "src/locales";
// assets
import { ForbiddenIllustration } from "src/assets/illustrations";
// components
import { MotionContainer, varBounce } from "src/components/animate";

// ----------------------------------------------------------------------

export default function RoleBasedGuard({
  permissionBased = true,
  permissions = [],
  ownerOnly = false,
  children,
  sx,
}) {
  const { user, hasPermissions, hasEnterpriseRoles, authenticated } = useAuthContext();
  const { t } = useLocales();

  // ownerOnly: el owner tiene todos los permisos, así que ningún permiso lo distingue de otro usuario.
  let validationResult;
  if (ownerOnly) validationResult = user?.owner === true;
  else if (permissionBased) validationResult = hasPermissions(permissions);
  else validationResult = hasEnterpriseRoles(permissions);

  if (!authenticated) return null;

  if (!validationResult) {
    return (
      <Container
        component={MotionContainer}
        sx={{ textAlign: "center", ...sx }}
      >
        <m.div variants={varBounce().in}>
          <Typography
            variant="h3"
            paragraph
          >
            {t("error:permissionDenied")}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: "text.secondary" }}>
            {t("error:youDontHavePermission")}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>
      </Container>
    );
  }

  return <> {children} </>;
}

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  permissionBased: PropTypes.bool,
  permissions: PropTypes.arrayOf(PropTypes.string),
  ownerOnly: PropTypes.bool,
  sx: PropTypes.object,
};
